// extracted by mini-css-extract-plugin
export default {"editor":"Editor_editor__BY7Q0"};